module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "paratime-selector-globe.0ad455d3.svg";